module.exports = __webpack_public_path__ + "assets/images/JMDBAG20.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMDBAG20.png
// module id = 1392
// module chunks = 1